import React from 'react'
import Homepage from './pages/home/HomePage'


function App() {
  return (
    <div>
     
      <Homepage />
    </div>
  )
}

export default App
